import { FC, useCallback, useContext } from 'react';
import {Route, Redirect, RouteProps} from 'react-router-dom';
import { DashboardProvider } from '../../dashboard/useDashboardContext';
import { AuthContext } from '../../auth/useAuthContext';
import { Constants } from '../../utils/constants';
import SelectPlan from '../../auth/SelectPlan';
import { useIsFlagEnabled } from '../../shared/hooks/useIsFlagEnabled';

interface IProps extends RouteProps {
  component: any;
}

export const PrivateRoute: FC<IProps> = ({ component: Component, ...rest }) => {
  const { state: authState } = useContext(AuthContext);
  const isSubscriptionEnabled = useIsFlagEnabled('paystack_business_subscription');

  const dashboardProvider = useCallback((props: RouteProps) => {
    if (!authState.user.subscription && isSubscriptionEnabled) return <SelectPlan showAlert={true} />;

    return <DashboardProvider routerProps={props}>
      <Component {...props} />
    </DashboardProvider>;
  },[authState.user]);

  const setRoute = (props: RouteProps) => {
    if (authState.user) {
      if (!isSubscriptionEnabled) return dashboardProvider(props);

      if (authState.user.subscription) {
        return dashboardProvider(props);
      } else {
        return <SelectPlan showAlert={true} />;
      }
    } else {
      return <Redirect to={Constants.Links.Auth.Path.Login} />;
    }
  };

  return (
    <Route
      {...rest}
      render={props => setRoute(props)}
    />
  );
};
